import resultsApi from '../data/resultsApi';

const getResults = async (categoryId: string, flavourIds: string[], tasteIds: string[], mouthfeelIds: string[]) => {
  return resultsApi.getResults(categoryId, flavourIds, tasteIds, mouthfeelIds);
};


const resultsService = {
  getResults,
};

export default resultsService;
